// core/device — sidik-jari perangkat (proxy anti-titip). Port deviceFP/deviceToken v0.18.
// CATATAN: IMEI/SN hardware TAK bisa dibaca browser (privasi). Ini proxy: hash atribut browser
// (deviceFp) + token acak di localStorage (deviceToken). Ganti HP/clear-storage → token baru
// → dianggap HP baru (Manager reset agar bisa daftar ulang). Berjalan di browser (bukan SSR).

/** FNV-1a 32-bit hash dari atribut perangkat → sidik-jari stabil per browser/HP. */
export function deviceFp(): string {
  try {
    const parts = [
      navigator.userAgent, navigator.platform, navigator.language,
      screen.width + 'x' + screen.height, String(screen.colorDepth),
      String(navigator.hardwareConcurrency || 0), String(new Date().getTimezoneOffset()),
    ].join('|');
    let h = 2166136261 >>> 0;
    for (let i = 0; i < parts.length; i++) { h ^= parts.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
    return h.toString(36);
  } catch { return 'nofp'; }
}

/** Token perangkat: tersimpan di localStorage; sekali dibuat tetap (kecuali storage di-clear / HP baru). */
export function deviceToken(): string {
  try {
    const k = 'ifics_dev';
    let v = localStorage.getItem(k);
    if (!v) { v = deviceFp() + '-' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36); localStorage.setItem(k, v); }
    return v;
  } catch { return 'nostore-' + deviceFp(); }
}
